var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreBanne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.11 21.07",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d69fa;\n        stroke: #4d69fa;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.14,20.94H2.86c-.18,0-.32-.13-.32-.29v-10.74h.64v10.45h19.65v-10.45h.64v10.74c0,.16-.14.29-.32.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.26,10.34h-1.03c-1.05,0-1.9-.85-1.9-1.9v-.8c0-.17.14-.32.32-.32h4.21c.17,0,.32.14.32.32v.81c0,1.05-.85,1.9-1.9,1.9h0Zm-2.3-2.4v.49c0,.7.57,1.27,1.27,1.27h1.03c.7,0,1.27-.57,1.27-1.27v-.49h-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.85,7.94h-4.21c-.1,0-.19-.04-.25-.12-.06-.08-.08-.17-.06-.27L6.02.37c.03-.14.16-.24.31-.24h3.36c.09,0,.18.04.24.11.06.07.09.16.08.25l-.84,7.19c-.02.16-.15.28-.31.28h0Zm-3.81-.63h3.53l.77-6.56h-2.76l-1.53,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.06,10.34h-1.03c-1.05,0-1.9-.85-1.9-1.9v-.8c0-.17.14-.32.32-.32h4.2c.17,0,.32.14.32.32v.81c0,1.05-.85,1.9-1.9,1.9h0ZM.76,7.94v.49c0,.7.57,1.27,1.27,1.27h1.03c.7,0,1.27-.57,1.27-1.27v-.49H.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.64,7.94H.44c-.1,0-.2-.05-.26-.13-.06-.08-.07-.19-.04-.29L2.67.34c.05-.12.16-.21.3-.21h3.36c.1,0,.19.04.25.12.06.08.08.17.06.27l-1.68,7.19c-.04.14-.16.24-.31.24h0Zm-3.76-.63h3.51L5.93.76h-2.74L.89,7.31Zm10.58,3.03h-1.03c-1.05,0-1.9-.85-1.9-1.9v-.8c0-.17.14-.32.32-.32h4.2c.17,0,.32.14.32.32v.81c0,1.05-.85,1.9-1.9,1.9h0Zm-2.3-2.4v.49c0,.7.57,1.27,1.27,1.27h1.03c.7,0,1.27-.57,1.27-1.27v-.49h-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.05,7.94h-4.2c-.09,0-.18-.04-.24-.11-.06-.07-.09-.16-.08-.25l.84-7.19c.02-.16.15-.28.31-.28h3.36c.17,0,.32.14.32.32v7.19c0,.17-.14.32-.32.32h0Zm-3.85-.63h3.53V.76h-2.76l-.77,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.67,10.34h-1.03c-1.05,0-1.9-.85-1.9-1.9v-.8c0-.17.14-.32.32-.32h4.2c.17,0,.32.14.32.32v.81c0,1.05-.85,1.9-1.9,1.9h0Zm-2.3-2.4v.49c0,.7.57,1.27,1.27,1.27h1.03c.7,0,1.27-.57,1.27-1.27v-.49h-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.26,7.94h-4.2c-.17,0-.32-.14-.32-.32V.45c0-.17.14-.32.32-.32h3.36c.16,0,.29.12.31.28l.84,7.19c0,.09-.02.18-.08.25-.06.07-.15.11-.24.11h0Zm-3.89-.63h3.53l-.77-6.56h-2.76v6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.88,10.34h-1.03c-1.05,0-1.9-.85-1.9-1.9v-.8c0-.17.14-.32.32-.32h4.21c.17,0,.32.14.32.32v.81c0,1.05-.85,1.9-1.9,1.9h0Zm-2.3-2.4v.49c0,.7.57,1.27,1.27,1.27h1.03c.7,0,1.27-.57,1.27-1.27v-.49h-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.46,7.94h-4.21c-.16,0-.29-.12-.31-.28l-.84-7.19c0-.09.02-.18.08-.25.06-.07.15-.11.24-.11h3.36c.15,0,.27.1.31.24l1.68,7.19c.02.09,0,.19-.06.27-.06.08-.15.12-.25.12h0Zm-3.92-.63h3.53l-1.53-6.56h-2.76l.77,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.08,10.34h-1.03c-1.05,0-1.9-.85-1.9-1.9v-.8c0-.17.14-.32.32-.32h4.2c.17,0,.32.14.32.32v.81c0,1.05-.85,1.9-1.9,1.9h0Zm-2.3-2.4v.49c0,.7.57,1.27,1.27,1.27h1.03c.7,0,1.27-.57,1.27-1.27v-.49h-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.67,7.94h-4.2c-.15,0-.27-.1-.31-.24l-1.68-7.19c-.02-.09,0-.19.06-.27.06-.08.15-.12.25-.12h3.36c.13,0,.25.08.3.21l2.52,7.19c.03.1.02.2-.04.29-.06.08-.15.13-.26.13h0Zm-3.95-.63h3.51l-2.3-6.56h-2.74l1.53,6.56Zm-10.05,13.63h-3.47c-.08,0-.16-.03-.22-.09-.06-.06-.09-.14-.09-.22v-8.39c0-.08.03-.16.09-.22.06-.06.14-.09.22-.09h3.47c.17,0,.32.14.32.32v8.39c0,.08-.03.16-.09.22-.06.06-.14.09-.22.09h0Zm-3.15-.63h2.84v-7.76h-2.84v7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.19,20.94h-3.47c-.17,0-.32-.14-.32-.32v-8.39c0-.17.14-.32.32-.32h3.47c.17,0,.32.14.32.32v8.39c0,.17-.14.32-.32.32h0Zm-3.15-.63h2.84v-7.76h-2.84v7.76Zm16.65-2.61h-8.62c-.17,0-.32-.14-.32-.32v-5.15c0-.17.14-.32.32-.32h8.62c.17,0,.32.14.32.32v5.15c0,.17-.14.32-.32.32h0Zm-8.3-.63h7.98v-4.52h-7.98v4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.7,18.92h-8.62c-.17,0-.32-.14-.32-.32v-1.22c0-.17.14-.32.32-.32h8.62c.17,0,.32.14.32.32v1.22c0,.17-.14.32-.32.32h0Zm-8.3-.63h7.98v-.59h-7.98v.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.94,
    y: 20.31,
    width: 24.22,
    height: 0.63,
    rx: 0.32,
    ry: 0.32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreBanne);
export default __webpack_public_path__ + "static/media/store-banne.ff7be10ed643ca1186c274aaf48f89fe.svg";
export { ForwardRef as ReactComponent };